import { useContext } from 'react';
import { InvitePeopleModalContext } from './InvitePeopleModalContext';
/**
Allows opening and closing of the Invite People Modal from within the InvitePeopleModalContext
*/
export const useInvitePeopleModal = useInvitePeopleModalProps => {
  const {
    onClose,
    ...invitePeopleProps
  } = useInvitePeopleModalProps;
  const {
    openModal,
    closeModal,
    isOpen
  } = useContext(InvitePeopleModalContext);
  return {
    // this is experimental only and should not be used without consulting !core-invtes in #groot-techops
    experimental_openModal: propsOverride => openModal({
      ...invitePeopleProps,
      ...propsOverride
    }, onClose),
    openModal: () => openModal(invitePeopleProps, onClose),
    closeModal,
    isOpen
  };
};